import { render, staticRenderFns } from "./MediaLibraryImage.vue?vue&type=template&id=f6b035a6&"
import script from "./MediaLibraryImage.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports